import { Component, Input, ViewChildren, QueryList } from '@angular/core';
import { NgModel } from '@angular/forms';
import { UtilService } from '../../shared/services/util.service';
import { HouseViewsService } from '../../shared/services/house-views.service';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';
import { CleanNamePipe } from '../../shared/services/clean-name.pipe';
import { ConfidenceLabelPipe } from '../../shared/services/confidence-label.pipe';
import { BenchmarkSelectorForViewsComponent } from '../benchmark-selector-for-views/benchmark-selector-for-views.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-house-views-setter',
  templateUrl: './house-views-setter.component.html',
  styleUrls: ['./house-views-setter.component.scss'],
  imports: [MaterialModule, FormsModule, CleanNamePipe, ConfidenceLabelPipe, BenchmarkSelectorForViewsComponent, CommonModule],
  standalone: true,
})
export class HouseViewsSetterComponent {

  @Input() mode: 'user' | 'firm' = 'user';
  @Input() views: any[] = [];
  @Input() companyId?: number;
  @ViewChildren(NgModel) formControls: QueryList<NgModel>;

  activeView: any = {};

  types = [
    { id: 'macro', name: 'Macro' },
  ];

  viewTypes = [
    { id: 'absolute', name: 'Absolute' },
  ];

  confidenceLevels = [
    { value: 90, label: 'Certain' },
    { value: 70, label: 'High' },
    { value: 50, label: 'Moderate' },
    { value: 30, label: 'Low' },
    { value: 'custom', label: 'Custom' },
  ];

  confidenceSelectValue: number | 'custom' = null;
  formSubmitted = false;

  onConfidenceSelectChange(value: number | 'custom') {
    if (value !== 'custom') {
      this.activeView.confidence = value;
    } else {
      this.activeView.confidence = null;
    }
  }

  constructor(
    private util: UtilService,
    private service: HouseViewsService,
  ) {}

  onBenchmarkSelected(selected: any) {
    this.activeView.items = selected;
    this.activeView.frequency = selected?.frequency ?? null;
  }

  initActiveView() {
    return {
      type: 'macro',
      view_type: 'absolute',
    };
  }

  onAddView() {
    this.activeView = this.initActiveView();
    this.confidenceSelectValue = null;
  }

  isFormValid(): boolean {
    const v = this.activeView;
    if (!v.type) return false;
    if (!v.items) return false;
    if (!v.view_type) return false;
    if (v.value == null || v.value === '') return false;
    if (v.confidence == null || v.confidence === '') return false;
    return true;
  }

  saveView() {
    this.formSubmitted = true;
    this.formControls.forEach(c => c.control.markAsTouched());
    if (!this.isFormValid()) {
      return;
    }

    const payload = { ...this.activeView };

    if (payload.type === 'macro') {
      payload.items = [payload.items.id];
    }

    delete payload.items2;
    delete payload.take;
    delete payload.frequency;

    const createFn = this.mode === 'firm'
      ? this.service.createFirmView(payload, this.companyId)
      : this.service.createUserView(payload);

    createFn.subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error);
      }
      if (this.activeView.id) {
        this.views = this.util.findAndReplaceItemInArray(resp, this.views);
      } else {
        this.views.push(resp);
      }
      this.discardView();
    });
  }

  editView(c: any) {
    this.activeView = { ...c };
    this.activeView.type = c.type.id;

    if (c.items && c.items.length > 0) {
      c.items = c.items.map((i: any) => {
        if (!i.name_full) {
          i.name_full = i.name;
        }
        return i;
      });
    }
    this.activeView.items = c.items[0];

    const presetValues = [90, 70, 50, 30];
    this.confidenceSelectValue = presetValues.includes(c.confidence) ? c.confidence : 'custom';
  }

  deleteView(v: any) {
    const deleteFn = this.mode === 'firm'
      ? this.service.deleteFirmView(v)
      : this.service.deleteUserView(v);

    deleteFn.subscribe(() => {
      this.views = this.views.filter(view => view.id !== v.id);
    });
  }

  discardView() {
    this.activeView = {};
    this.confidenceSelectValue = null;
    this.formSubmitted = false;
  }

  getTypeName(type: any): string {
    if (!type) return '';
    const id = type.id || type;
    const found = this.types.find(t => t.id === id);
    return found ? found.name : id;
  }

}
